// This file is generated by pnpm icons:generate. Do not edit.

import {CalendarClock_Stroke2_Corner0_Rounded as CanonicalCalendarClock_Stroke2_Corner0_Rounded} from './Calendar'

/** @deprecated Import CalendarClock_Stroke2_Corner0_Rounded from `#/components/icons/Calendar` instead. */
export const CalendarClock_Stroke2_Corner0_Rounded =
  CanonicalCalendarClock_Stroke2_Corner0_Rounded
